<template>
    <v-dialog v-if="dialog" v-model="dialog" persistent max-width="600px">
        <v-card>
            <v-app-bar flat>
                <v-toolbar-title class="text-h6 pl-0">
                    Attenzione
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-app-bar>
            <v-card-text>
                <v-container>
                    <p>Confermi la cancellazione del progetto?</p>
                    <p>
                        Procedendo cancellerai tutte le attività, prodotti, sotto attività e task collegati
                    </p>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="confirm">Procedi</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    props: {
        projectId: {
            required: true
        },
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialog: false,
        }
    },
    watch: {
        value: {
            handler() {
                this.dialog = this.value
            },
            immediate: true
        },
        dialog() {
            this.$emit('input', this.dialog)
        }
    },
    methods: {
        close() {
            this.dialog = false;
            this.$emit('closed')
        },
        confirm() {
            this.$projectService.delete(this.projectId).then(
                () => {
                    this.$dtoast.pop({
                        preset: "success",
                        content: 'Progetto eliminato',
                    })
                    this.dialog = false;
                    this.$emit('confirmed')
                }
            )
        }
    }
}
</script>
